<template>
  <v-card class="section-card mb-4" elevation="0">
    <div class="section-header d-flex align-center pa-4" style="cursor:pointer" @click="expanded = !expanded">
      <v-avatar color="secondary" size="36" class="mr-3">
        <v-icon dark small>table_chart</v-icon>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="section-title">Fichier PLU</div>
        <div class="section-subtitle">Jusqu'à 3 fichiers distincts : Traditionnels, Libre-Service et Recettes</div>
      </div>
      <v-btn icon small class="ml-2">
        <v-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
    </div>
    <v-divider />
    <v-card-text class="pa-6 plu-section-body">
      <template v-if="loading">
        <v-row justify="center">
          <v-col cols="12" md="7">
            <v-skeleton-loader type="paragraph" class="mb-3" />
            <v-skeleton-loader type="image" height="80" />
            <v-skeleton-loader type="image" height="80" class="mt-3" />
            <v-skeleton-loader type="image" height="80" class="mt-3" />
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row justify="center">
          <v-col cols="12">
            <v-expand-transition>
              <v-alert v-if="expanded" dense text color="#1D6F42" class="mb-4" icon="table_view">
                <div class="caption mb-1">Format attendu du fichier Excel :</div>
                <v-simple-table dense class="plu-format-table">
                  <template #default>
                    <thead>
                      <tr>
                        <th class="caption">Colonne A</th>
                        <th class="caption">Colonne B</th>
                        <th class="caption">Colonne C</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="caption font-weight-bold">EAN</td>
                        <td class="caption font-weight-bold">PLU</td>
                        <td class="caption font-weight-bold">NOM</td>
                      </tr>
                      <tr>
                        <td class="caption grey--text">0201234000000</td>
                        <td class="caption grey--text">1234</td>
                        <td class="caption grey--text">{{ isBoucherie ? 'FILET DE BOEUF' : 'CREVETTES GRISES' }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-alert>
            </v-expand-transition>

            <v-row style="align-items: stretch;">
              <v-col cols="12" md="4" class="d-flex flex-column">
                <div class="plu-type-label mb-1">Traditionnels</div>
                <div class="plu-upload-wrap flex-grow-1">
                <FileUpload
                  :value="value.traditionnel"
                  @input="emitUpdate('traditionnel', $event)"
                  :formats="['.xls', '.xlsx']"
                  uploadTitle="Fichier PLU Traditionnels"
                  :multiple="false"
                  :service="'plu'"
                  :model="model"
                  :code="code"
                  :pluType="'traditionnel'"
                  maxHeight="120px"
                  :loading="loading"
                />
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <div class="plu-type-label mb-1">Libre-Service</div>
                <div class="plu-upload-wrap flex-grow-1">
                <FileUpload
                  :value="value.libreService"
                  @input="emitUpdate('libreService', $event)"
                  :formats="['.xls', '.xlsx']"
                  uploadTitle="Fichier PLU Libre-Service"
                  :multiple="false"
                  :service="'plu'"
                  :model="model"
                  :code="code"
                  :pluType="'libre-service'"
                  maxHeight="120px"
                  :loading="loading"
                />
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <div class="plu-type-label mb-1">Recettes (produit transformé)</div>
                <div class="plu-upload-wrap flex-grow-1">
                <FileUpload
                  :value="value.recettes"
                  @input="emitUpdate('recettes', $event)"
                  :formats="['.xls', '.xlsx']"
                  uploadTitle="Fichier PLU Recettes"
                  :multiple="false"
                  :service="'plu'"
                  :model="model"
                  :code="code"
                  :pluType="'recettes'"
                  maxHeight="120px"
                  :loading="loading"
                />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'

export default {
  name: 'PluSection',
  components: { FileUpload },
  props: {
    value: {
      type: Object,
      default: () => ({ traditionnel: { files: [] }, libreService: { files: [] }, recettes: { files: [] } })
    },
    model: { type: [Object, Array], default: () => ({}) },
    code: { type: [Number, String], default: null },
    loading: { type: Boolean, default: false },
    metier: { type: Object, default: () => ({ key: 'poissonnerie' }) },
  },
  computed: {
    isBoucherie () {
      return this.metier.key === 'boucherie'
    }
  },
  data () {
    return {
      expanded: false,
    }
  },
  methods: {
    emitUpdate (key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue })
    }
  }
}
</script>

<style scoped lang="scss">
.plu-format-table {
  background: transparent !important;
  th, td {
    padding: 2px 8px !important;
    border-bottom: 1px solid rgba(0,0,0,0.08) !important;
    height: auto !important;
  }
  thead th {
    color: #546e7a !important;
    font-weight: 600 !important;
  }
}
.plu-section-body {
  max-height: 520px;
  overflow-y: auto;
}
.plu-upload-wrap {
  height: 340px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.plu-upload-wrap > * {
  flex-shrink: 0;
}
plu-secion{
  font-size: 0.85rem;
  font-weight: 600;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
</style>
